import {StandardDialogFooter} from "../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import React, {useEffect, useState} from "react";
import BarekamInput from "../../../../pages/components/input";
import {useAppDispatch, useAppSelector} from "../../../../redux/store";
import {Message, MessageSections} from "../../../../pages/components/message/message";
import {WarehouseModel} from "../../../../pages/shared/models/order/warehouse.model";
import {AxiosError} from "axios";
import {mapValidationErrors} from "../../../../pages/user/settings/personal-info/personal-info.service";
import BarekamPhoneInput from "../../../../pages/auth/phone-input/phone-input";
import {CountryModel} from "../../../../pages/shared/models/countryModel";
import {User} from "../../../../pages/shared/models/user/user";
import {useParams} from "react-router-dom";
import {ARMENIA_COUNTRY_ID} from "../../../../constants";
import {changeErrors} from "../../../../redux/slices/register-slice";
import {UserTypeEnum} from "../../../../pages/shared/enum/user-type.enum";
import {UserGroups} from "../../../../router/router";
import authService from "../../../../services/auth.service";
import {ActionDialogContent} from "./shared/styled";
import {getMessage} from "../../../../pages/shared/helper-functions";

const NewWarehouseWorker = ({onCancel}: NewUserDialogProps) => {
    const [warehouse, setWarehouse] = useState<WarehouseModel>();
    const [country, setCountry] = useState<CountryModel>();

    const {warehouseId} = useParams()

    const {countries} = useAppSelector(state => state.staticDataReducer);

    const [newUserData, setNewUserData] = useState<User>();
    const [repeatedPassword, setRepeatedPassword] = useState('');

    useEffect(() => {
        const relatedCountry = warehouseId && countries.find(country => country.warehouse.some(warehouse => warehouse.warehouseId === +warehouseId));
        const paramWarehouse = relatedCountry && relatedCountry.warehouse.find(warehouse =>  warehouse.warehouseId === +warehouseId);

        if (paramWarehouse && relatedCountry) {
            setWarehouse(paramWarehouse);
            setCountry(relatedCountry);
        }
    }, [warehouseId])

    useEffect(() => {
        if (warehouse && country) {
            setNewUserData({
                firstName: '',
                lastName: '',
                entityName: '',
                email: '',
                phoneNumber: '',
                password: '',
                userGroup: country?.countryId === ARMENIA_COUNTRY_ID //
                ? {userGroupId: UserGroups.LOCAL_WAREHOUSE_WORKER, name: ''}
                : {userGroupId: UserGroups.WAREHOUSE_WORKER, name: ''},
                type: UserTypeEnum.PHYSICAL_PERSON,
                locationId: country,
                warehouse: warehouse,
            })
        }
    }, [warehouse, country])

    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    const dispatch = useAppDispatch();

    function onChange(field: 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'password', value: any) {
        setNewUserData(prevState => {
            if (prevState) {
                prevState[field] = value;
                return {...prevState};
            }
        })
    }

    function passedValidations() {
        if (repeatedPassword !== newUserData?.password) {
            dispatch(changeErrors({errors: {password: {message: 'passwords_do_not_match'}}}))

            return false;
        } else {
            return true
        }
    }

    function createWarehouseWorker() {
        if (passedValidations() && newUserData) {
            const newUserClone = {...newUserData} as any;

            newUserClone.locationId = newUserData.locationId.countryId;
            newUserClone.warehouse = newUserData.warehouse?.warehouseId;
            newUserClone.userGroup = newUserData.userGroup.userGroupId;

            authService.createWithJWT(newUserClone)
                .then((response: any) => {
                    if (response) {
                        onCancel();
                    }
                })
                .catch(e => {
                    if (e instanceof AxiosError) {
                        setErrors(mapValidationErrors(e));
                    }
                });
        }
    }

    if (newUserData) {
        return (
            <>
                <ActionDialogContent>
                    <BarekamInput key={'register-first-name'}
                                  customInputVariant={"standard"}
                                  placeholder={getMessage('first_name', MessageSections.USER, messageCache, languageId)}
                                  value={newUserData?.firstName}
                                  onChange={(value) => onChange('firstName', value.target.value)}
                                  type={'text'}
                                  error={!!errors['firstName']}
                                  errorMessage={errors['first_name'] && getMessage(errors['first_name'], MessageSections.USER, messageCache, languageId)}
                                  width={'100%'}
                                  required/>

                    <BarekamInput key={'register-last-name'}
                                  customInputVariant={"standard"}
                                  placeholder={getMessage('last_name', MessageSections.USER, messageCache, languageId)}
                                  value={newUserData?.lastName}
                                  onChange={(value) => onChange('lastName', value.target.value)}
                                  type={'text'}
                                  error={!!errors['lastName']}
                                  errorMessage={errors['lastName'] && getMessage(errors['lastName'], MessageSections.USER, messageCache, languageId)}
                                  width={'100%'}
                                  required/>

                    <BarekamInput key={'register-email'}
                                  customInputVariant={"standard"}
                                  placeholder={getMessage('email', MessageSections.USER, messageCache, languageId)}
                                  value={newUserData?.email}
                                  onKeyUp={(event) => event.key === 'Enter' && createWarehouseWorker()}
                                  onChange={(value) => onChange('email', value.target.value)}
                                  type={'email'}
                                  error={!!errors['email']}
                                  errorMessage={errors['email'] && getMessage(errors['email'], MessageSections.USER, messageCache, languageId)}
                                  width={'100%'}
                                  required/>

                    <BarekamPhoneInput key={'register-phone-number'}
                                       value={''}
                                       placeholder={getMessage('phone_number', MessageSections.USER, messageCache, languageId)}
                                       onKeyUp={(event) => event.key === 'Enter' && createWarehouseWorker()}
                                       onChange={(value: number) => onChange( 'phoneNumber', value)}
                                       error={!!errors['phoneNumber']}
                                       errorMessage={errors['phoneNumber'] && getMessage(errors['phoneNumber'], MessageSections.USER, messageCache, languageId)}/>

                    <BarekamInput key={'register-password'}
                                  customInputVariant={"standard"}
                                  placeholder={getMessage('password', MessageSections.USER, messageCache, languageId)}
                                  value={newUserData?.password}
                                  onKeyUp={(event) => event.key === 'Enter' && createWarehouseWorker()}
                                  onChange={(value) => onChange('password', value.target.value)}
                                  type={'password'}
                                  error={!!errors['password']}
                                  width={'100%'}
                                  required/>

                    <BarekamInput key={'register-repeat-password'}
                                  customInputVariant={"standard"}
                                  placeholder={getMessage('repeat_password', MessageSections.USER, messageCache, languageId)}
                                  value={repeatedPassword}
                                  onChange={(value) => setRepeatedPassword(value.target.value)}
                                  onKeyUp={(event) => event.key === 'Enter' && createWarehouseWorker()}
                                  type={'password'}
                                  error={!!errors['password']}
                                  errorMessage={errors['password'] && getMessage(errors['password'], MessageSections.USER, messageCache, languageId)}
                                  width={'100%'}
                                  required/>
                </ActionDialogContent>

                <StandardDialogFooter onCancel={() => onCancel()}
                                      onSave={() => createWarehouseWorker()}
                                      saveLabel={<Message messageKey={'create'} sectionId={MessageSections.ORDERS}/>}/>
            </>
        );
    } else {
        return <></>
    }
}

interface NewUserDialogProps {
    onCancel: () => void,
}

export default NewWarehouseWorker;